import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'shared-lib';
import { CustomerHistoryDataOut } from 'src/app/models/history.model';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-history-modal',
  templateUrl: './customer-history-modal.component.html',
  styleUrls: ['./customer-history-modal.component.scss'],
})
export class CustomerHistoryModalComponent {
  @Input() historyItems: CustomerHistoryDataOut[] = [];

  isJsonModalOpened: boolean = false;
  selectedJsonLines: string[] = [];
  jsonCopied: boolean = false;

  constructor(private authService: AuthService, private customerService: CustomerService, private toastr: ToastrService) {}

  get isCimEnabled(): boolean {
    return this.authService.hasCimDataIntegration;
  }

  openJson(item: CustomerHistoryDataOut) {
    this.customerService.getHistoryJsonData(item.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          const formatted = this.formatJson(responseData.data);
          this.selectedJsonLines = formatted ? formatted.split('\n') : [];
          this.isJsonModalOpened = true;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  private formatJson(json: string): string {
    if (!json) return '';
    try {
      return JSON.stringify(JSON.parse(json), null, 2);
    } catch {
      return json;
    }
  }

  copyJson() {
    const text = this.selectedJsonLines.join('\n');
    navigator.clipboard.writeText(text).then(() => {
      this.jsonCopied = true;
      setTimeout(() => (this.jsonCopied = false), 2000);
    });
  }

  closeJson() {
    this.isJsonModalOpened = false;
    this.selectedJsonLines = [];
    this.jsonCopied = false;
  }
}
